// ZB-2026-04-05 | Injecting custom CSS into shadow-root of wishlist button on product card (remove/unload if app devs fixed this issue)
document.addEventListener("DOMContentLoaded", () => {

  // Define all CSS for inside the product card shadow root
  const cardWishlistCSS = `
    /* Base positioning and inner button styles */
    .xb-wishlist-button-collection[xb-placement=top-left] {
      left: 2px !important;
      top: 6px !important;
      
      button {
          background-color: transparent !important;
      }
      
      @media screen and (max-width: 470px) {
          & {
            top: 0 !important;
            left: -5px !important;
        }
      }
    }

    /* Conditional style applied when JS detects the parent attribute */
    :host([data-has-inventory="true"]) .xb-wishlist-button-collection[xb-placement=top-left] button {
      background-color: var(--zb-color-bg-white) !important;
      border-top-left-radius: 11px !important;
      border-top-right-radius: 11px !important;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
  `;

  const fixCardWishlistStyles = () => {
    // Target the shadow host element
    const collectionElements = document.querySelectorAll('xb-wishlist-button-collection');

    collectionElements.forEach(el => {
      // 1. Check for the outer parent condition and tag the host element
      if (el.closest('div.product-card-wrapper div.card[data-inventory-info-on-product]')) {
        el.setAttribute('data-has-inventory', 'true');
      }

      // 2. Inject the complete CSS block into the shadow root
      if (el.shadowRoot && !el.shadowRoot.querySelector('#custom-xb-card-styles')) {
        const styleTag = document.createElement('style');
        styleTag.id = 'custom-xb-card-styles';
        styleTag.textContent = cardWishlistCSS;
        el.shadowRoot.appendChild(styleTag);
      }
    });
  };

  // Execute immediately
  fixCardWishlistStyles();

  // Watch for dynamically loaded product cards
  const observer = new MutationObserver(() => {
    fixCardWishlistStyles();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});